var React = require('react');

function LinkedinInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.364827 7.31089H4.92996V22H0.364827V7.31089ZM2.64499 0C4.0995 0 5.28518 1.18802 5.28518 2.64539C5.28518 4.10275 4.0995 5.29558 2.64499 5.29558C1.18569 5.29077 0.00480035 4.10756 0 2.64539C0 1.18321 1.18089 0 2.64499 0C2.64019 0 2.64019 0 2.64499 0ZM7.78136 7.31089H12.1497V9.31657H12.2121C12.8217 8.16222 14.305 6.94534 16.5324 6.94534C21.1455 6.94534 22 9.98994 22 13.9436V22H17.4445V14.8575C17.4445 13.1548 17.4157 10.9615 15.0779 10.9615C12.7065 10.9615 12.3417 12.8181 12.3417 14.7324V22H7.79097V7.30608L7.78136 7.31089Z","fill":"#F9F8F2"}));
}

LinkedinInline.defaultProps = {"viewBox":"0 0 22 22","fill":"none"};

module.exports = LinkedinInline;

LinkedinInline.default = LinkedinInline;
